import { render, staticRenderFns } from "./ShareCustomersTeacher.vue?vue&type=template&id=2af43658"
import script from "./ShareCustomersTeacher.vue?vue&type=script&lang=js"
export * from "./ShareCustomersTeacher.vue?vue&type=script&lang=js"
import style0 from "./ShareCustomersTeacher.vue?vue&type=style&index=0&id=2af43658&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports